import styled, { css } from 'styled-components';

export const SocialLoginImage = styled.img`
  height: 22px;
  margin-right: 6px;

  ${({ isGoogle }) =>
    isGoogle &&
    css`
      height: 20px;
    `}
`;
